module.exports = __webpack_public_path__ + "img/user.44803aa4.png";